import moment from 'moment';
import React from 'react';
import {
  INotificationType,
  getNotifications,
  readNotification,
  setSelectedNotification,
} from 'store/features/notificationSlice';
import { useAppDispatch, useAppSelector } from 'hooks/useAppDispatchSelector';
import { useNavigate } from 'react-router-dom';
import { NotificationModuleEnum, modalEnum, usersRoles } from 'helpers/utils';
import toast from 'react-hot-toast';
import NoData from 'components/common/no-data-ui';
import { setModal } from 'store/features/modelSlice';
import { useTranslation } from 'react-i18next';

interface INotificationProps {
  notificationsList: INotificationType[];
  handleHideNotification: () => void;
}
export interface INotificationItem {
  _id?: string;
  title: string;
  description: string;
  to: string;
  type: string;
  module?: string;
  is_read: boolean;
  data: {
    appointment_id: string;
    vehicle_id: string;
  };
}

const Notifications: React.FC<INotificationProps> = ({
  notificationsList = [],
  handleHideNotification = () => {},
}) => {
  const dispatch = useAppDispatch();
  const { selectedOrganization, user } = useAppSelector(state => state.auth);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleSetSelectedNotification = (data: INotificationItem) => {
    try {
      if (
        data?.module === NotificationModuleEnum?.APPOINTMENT_REQUEST ||
        (data?.module === NotificationModuleEnum?.CONFIRM_SLOT &&
          user?.login_details[0]?.role_name === usersRoles?.FLEET_MANAGE)
      ) {
        if (
          selectedOrganization?.role_name !== usersRoles?.DEALER_ADMIN &&
          selectedOrganization?.role_name !== usersRoles?.SUPER_ADMIN &&
          selectedOrganization?.role_name !== usersRoles?.FLEET_MANAGE
        ) {
          toast.error(t('ERROR_ACCESS_SLOT_AVAILIBILITY'));
          return;
        }
        if (data?.module === NotificationModuleEnum?.APPOINTMENT_REQUEST && !data?.is_read) {
          dispatch(setSelectedNotification(data));
          navigate(`/slot-availability/${data?.data?.appointment_id}/slot-appointment`);
          handleHideNotification();
        } else if (data?.module === NotificationModuleEnum?.CONFIRM_SLOT) {
          if (selectedOrganization?.role_name !== usersRoles?.FLEET_MANAGE) {
            toast.error(t('ERROR_ACCESS_SLOT_CONFIRMATION'));
            return;
          }
          dispatch(setSelectedNotification(data));
          if (setModal) {
            dispatch(
              setModal({
                type: modalEnum.APPOINMENT_CONFIRMATION,
                content: {
                  title: t('workshopAppointment.bookAppointment'),
                  callBackFun: () => navigate('/workshop-appointments'),
                },
              }),
            );
          }
          handleHideNotification();
        } else {
          dispatch(readNotification({ notification_id: data?._id || '' }));
          dispatch(getNotifications({ params: { type: 'notification' } }));
          handleHideNotification();
        }
      }
    } catch (error) {}
  };
  return (
    <div className="flex flex-col justify-start items-start w-[362px] max-h-[calc(100vh-66px)] h-fit rounded-3 overflow-hidden z-10 bg-grey4">
      <div className="px-4 py-3 border-b-1 border-grey w-full">
        <label className="text-sm font-medium text-grey5">{t('Notification')}</label>
      </div>
      <div className="flex flex-col flex-1 items-start justify-start w-full overflow-y-auto">
        {notificationsList.length ? (
          [...notificationsList]
            .sort((a, b) => moment(b.date).diff(moment(a.date)))
            .map(notification => (
              <div className="flex flex-wrap px-4 py-2" key={notification?.date}>
                <label className="flex w-full text-base font-semibold mb-2">
                  {moment.unix(moment(notification?.date).unix()).format('DD MMM, YYYY')}
                </label>
                {[...notification.notifications]
                  .sort((a, b) => moment(b.created_at).diff(moment(a.created_at)))
                  .map(item => (
                    <div
                      className={`flex flex-wrap px-4 py-2 rounded-3 border-b-1 border-grey w-full h-fit hover:bg-grey4 cursor-pointer`}
                      key={item?.title}
                      onClick={() => (!item?.is_read ? handleSetSelectedNotification(item) : {})}
                    >
                      <label
                        className={`text-sm cursor-pointer ${
                          item?.is_read ? 'font-medium' : 'font-bold'
                        } w-full text-black1 break-words`}
                      >
                        {item?.title}
                      </label>
                      <p
                        className={`text-sm font-medium w-full cursor-pointer text-grey2 break-words ${
                          item?.is_read ? 'font-medium' : 'font-bold'
                        }`}
                      >
                        {item?.description}
                      </p>
                      <p className="text-xs font-regular w-full text-grey2 break-words mt-2">
                        {item?.created_at && item?.name
                          ? `${moment(item?.created_at).format('hh:mm a')} | ${item?.name}`
                          : ''}
                      </p>
                    </div>
                  ))}
              </div>
            ))
        ) : (
          <div className="py-4 flex items-center justify-center w-full">
            <NoData message={t('NO_NOTIFICATION')} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Notifications;
